export default "__VITE_ASSET__DhN$4Kwd__"